/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type PermissionKey = (typeof PermissionKey)[keyof typeof PermissionKey];

export const PermissionKey = {
    OrgBuildingCreate: 'OrgBuildingCreate',
    OrgUsersGet: 'OrgUsersGet',
    OrgUsersRead: 'OrgUsersRead',
    OrgUsersInvite: 'OrgUsersInvite',
    OrgUsersRoleUpdate: 'OrgUsersRoleUpdate',
    OrgUsersDelete: 'OrgUsersDelete',
    OrgUsersInviteOwner: 'OrgUsersInviteOwner',
    OrgUsersBuildingAccessRead: 'OrgUsersBuildingAccessRead',
    OrgUsersBuildingAccessUpdate: 'OrgUsersBuildingAccessUpdate',
    OrgBuildingPublish: 'OrgBuildingPublish',
    OrgBillingRead: 'OrgBillingRead',
    OrgSettingsRead: 'OrgSettingsRead',
    OrgSettingsUpdate: 'OrgSettingsUpdate',
    OrgDocumentPackTemplatesRead: 'OrgDocumentPackTemplatesRead',
    OrgDocumentPackTemplatesUpdate: 'OrgDocumentPackTemplatesUpdate',
    OrgDelete: 'OrgDelete',
    BuildingRead: 'BuildingRead',
    BuildingUpdate: 'BuildingUpdate',
    BuildingContactsRead: 'BuildingContactsRead',
    BuildingContactsUpdate: 'BuildingContactsUpdate',
    BuildingDocumentsRead: 'BuildingDocumentsRead',
    BuildingDocumentsUpdate: 'BuildingDocumentsUpdate',
    BuildingDocumentsDelete: 'BuildingDocumentsDelete',
    BuildingDocumentPrivacyUpdate: 'BuildingDocumentPrivacyUpdate',
    BuildingLogRead: 'BuildingLogRead',
    BuildingLogUpdate: 'BuildingLogUpdate',
    BuildingAccessControlRead: 'BuildingAccessControlRead',
    BuildingAccessControlUpdate: 'BuildingAccessControlUpdate',
    BuildingMaintenanceScheduleCreate: 'BuildingMaintenanceScheduleCreate',
    BuildingMaintenanceScheduleRead: 'BuildingMaintenanceScheduleRead',
    BuildingMaintenanceScheduleUpdate: 'BuildingMaintenanceScheduleUpdate',
    BuildingOccupantsRead: 'BuildingOccupantsRead',
    BuildingOccupantsUpdate: 'BuildingOccupantsUpdate',
    BuildingAssetRegisterRead: 'BuildingAssetRegisterRead',
    BuildingAssetRegisterUpdate: 'BuildingAssetRegisterUpdate',
    BuildingInboxRead: 'BuildingInboxRead',
    BuildingInboxUpdate: 'BuildingInboxUpdate',
    BuildingDocumentPacksManageApprovals:
        'BuildingDocumentPacksManageApprovals',
    BuildingDocumentPacksEditRequirements:
        'BuildingDocumentPacksEditRequirements',
    BuildingDocumentPacksContribute: 'BuildingDocumentPacksContribute',
    BuildingDocumentPacksReviewSubmissions:
        'BuildingDocumentPacksReviewSubmissions',
} as const;
